import { useSettingFaireDirectSignupModalRefresh } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectSignupModalRefresh";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface ISignUpCTAProps {
  disabled?: boolean;
  handleSubmit: () => void;
  isFaireDirect?: boolean;
  isSimplifiedSemDiscoverV2?: boolean;
}

export const SignUpCTA: React.FC<ISignUpCTAProps> = ({
  disabled,
  handleSubmit,
  isFaireDirect,
  isSimplifiedSemDiscoverV2,
}) => {
  const isFaireDirectSignupRefresh = useSettingFaireDirectSignupModalRefresh();
  const faireDirectSignupCopy = isFaireDirectSignupRefresh ? (
    <SignUpForFreeMessage />
  ) : (
    <StrictLocalMsg
      defaultMessage="Sign up"
      description={{
        text: "Call to action to begin the sign up flow (CTA button text)",
        img: "https://cdn.faire.com/fastly/0c705d043798ad67c119f649b03bfcea3e780aef74af6047e57fb743e6dc643d.png",
      }}
    />
  );

  const nonFaireDirectSignupCopy = isSimplifiedSemDiscoverV2 ? (
    <SignUpToSeePricingMessage />
  ) : (
    <SignUpForFreeMessage />
  );

  return (
    <Button
      onClick={handleSubmit}
      data-test-id="createAccountButton"
      style={{ width: "100%" }}
      disabled={disabled}
      variant="primary"
    >
      {isFaireDirect ? faireDirectSignupCopy : nonFaireDirectSignupCopy}
    </Button>
  );
};

const SignUpForFreeMessage = () => {
  return (
    <StrictLocalMsg
      defaultMessage="Sign up for free"
      description={{
        text: "Call to action to begin the sign up flow (CTA button text)",
        img: "https://cdn.faire.com/fastly/b4af2f5790b4e0752944ac056de2906b679cd6fd241b5101f29e827cc2523f2f.png",
      }}
    />
  );
};

const SignUpToSeePricingMessage = () => {
  return (
    <StrictLocalMsg
      defaultMessage="Sign up to see pricing"
      description={{
        text: "Call to action to begin the sign up flow (CTA button text)",
        img: "https://cdn.faire.com/fastly/538672aaa3cc745cbfebc29d46ee826f39d968645077b29d722811a7956affdf.png",
      }}
    />
  );
};
